<template>
  <div class="mobile_footer">
    <div class="mobile_title">联系我们</div>
    <div class="mobile_footer_con">
      <p>全国统一客服电话：400-6399580</p>
      <p>商务合作：13074700218</p>
      <p>公司地址：北京市朝阳区双井街道西大望路22号合生汇写字楼710室</p>
      <p>邮箱：liuyang@dinghanwang.com</p>
    </div>
    <div class="mobile_QR">
      <div v-for="(item, index) in QRcodeList" :key="index" class="mobile_QR_item"  >
        <img :src="item.img" alt="" />
        <p>{{ item.name }}</p>
      </div>
    </div>
    <div class="mobile_right">
      <p>Copyright©{{ year }}鼎函科技有限公司 版权所有</p>
      <p  @click="goRight">京ICP备2022017360号 京公网安备11010502050505号</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  mixins: [],
  components: {},
  props: {},
  data() {
    return {
      year: new Date().getFullYear(),
      QRcodeList: [
        {
          img: require("../../../static/other/footer-img1.jpg"),
          name: "微信公众号",
        },
        {
          img: require("../../../static/other/footer-img2.jpg"),
          name: "抖音号",
        },
        {
          img: require("../../../static/other/footer-img3.jpg"),
          name: "微信客服",
        },
      ],
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {
    goRight(){
        window.open('https://beian.miit.gov.cn/')
    }
  },
};
</script>

<style scoped>
.mobile_footer{
    width: 100%;
    background: rgb(26, 56, 98);
    padding-top: 2.5rem ;
    box-sizing: border-box;

}

.mobile_footer_con p{
    margin-bottom: 1.2rem;
    margin-left: 1.2rem;
}
.mobile_QR{
    width: 100%;
    display: flex;
    /* gap: 1rem; */
    justify-content: center;
    margin: 2rem 0 3rem 0;
}
.mobile_QR_item{
    width: 28%;
    display: flex;
    flex-direction: column;
    align-items: center;

}
.mobile_QR .mobile_QR_item:nth-child(2){
  margin: 0 1rem;
}
.mobile_QR img{
    width: 100%;
}
.mobile_right{
    color: #A9CEF2;
    font-size: 0.9rem;
    padding-bottom:0.5rem
}
.mobile_right p{
    text-align: center;
    margin-top: 0.8rem;
}
</style>
